import { getTheme } from "../configs/themes";
import React, { useEffect } from "react";

const ThemeProvider = ({ children }) => {
  useEffect(() => {
    const theme = getTheme();
    const root = document.documentElement;

    root.style.setProperty("--color-primary", theme.primary);
    root.style.setProperty("--color-primary-hover", theme.primaryHover);
    root.style.setProperty("--color-secondary", theme.secondary);
    root.style.setProperty("--color-accent", theme.accent);
    root.style.setProperty("--color-accent-hover", theme.accentHover);

    // Update Title
    document.title = theme.title;

    // Update Favicon
    const favicon = document.querySelector("link[rel='icon']");
    if (favicon) {
      favicon.href = theme.favicon;
    }
  }, []);

  return <>{children}</>;
};

export default ThemeProvider;
